export default __webpack_public_path__ + "static/media/chart dark.3e74b5b9.svg";